import { BaseModel } from "../base.model";

export class FormTemplateVersion extends BaseModel {
  id: number;
  versionGroup: number;
  version: number;
}
